import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { AvatarComponent } from '../avatar/avatar.component';

@Component({
  selector: 'app-avatar-group',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [AvatarComponent],
  template: `
    <div class="avatar-group" [attr.aria-label]="ariaLabel()" [title]="ariaLabel()">
      @for (name of visibleNames(); track $index) {
        <span class="avatar-group__item" [style.margin-left.rem]="$index === 0 ? 0 : -overlapRem()">
          <app-avatar [name]="name" [size]="size()" />
        </span>
      }
      @if (overflow() > 0) {
        <span
          class="avatar-group__overflow"
          [style.margin-left.rem]="-overlapRem()"
          [style.width.rem]="sizeRem()"
          [style.height.rem]="sizeRem()"
          [style.font-size.rem]="sizeRem() * 0.36"
          aria-hidden="true"
        >
          +{{ overflow() }}
        </span>
      }
    </div>
  `,
  styles: `
    :host {
      display: inline-flex;
    }
    .avatar-group {
      display: inline-flex;
      align-items: center;
    }
    .avatar-group__item {
      display: inline-flex;
      border: 2px solid var(--to-card, #fff);
      border-radius: 50%;
    }
    .avatar-group__overflow {
      display: grid;
      place-items: center;
      border-radius: 50%;
      border: 2px solid var(--to-card, #fff);
      background: var(--to-border-soft, #e5e7eb);
      color: var(--to-text-muted, #6b7280);
      font-weight: 600;
      letter-spacing: 0.02em;
      user-select: none;
      flex-shrink: 0;
    }
  `,
})
export class AvatarGroupComponent {
  readonly names = input.required<string[]>();
  readonly size = input<number>(24);
  readonly maxVisible = input<number>(3);

  readonly sizeRem = computed(() => this.size() / 16);
  readonly overlapRem = computed(() => this.sizeRem() * 0.3);

  readonly visibleNames = computed(() => {
    const all = this.names();
    const max = this.maxVisible();
    return all.length <= max ? all : all.slice(0, Math.max(1, max - 1));
  });

  readonly overflow = computed(() => {
    const all = this.names();
    return all.length - this.visibleNames().length;
  });

  readonly ariaLabel = computed(() => {
    const all = this.names();
    if (all.length === 0) return '';
    if (all.length === 1) return all[0];
    return all.slice(0, -1).join(', ') + ' und ' + all[all.length - 1];
  });
}
